export default "__VITE_ASSET__Bm0DEq8d__"